import { CardLoader } from 'components/organisms'
import withLoader from 'hocs/with-loader'
import PropTypes from 'prop-types'
import React from 'react'
import { Table } from 'reactstrap'
import ScraperProductTableRow from 'domains/scraper-product/organisms/scraper-product-table/scraper-product-table-row'
import PaginationBar from 'components/organisms/pagination-bar/pagination-bar'

const propTypes = {
  scraperProducts       : PropTypes.array,
  tableProps            : PropTypes.object,
  pagination            : PropTypes.object,
  isLoading             : PropTypes.bool,
  handleRejectCuration  : PropTypes.func,
  onClickWebsite        : PropTypes.func,
  onClickCurate         : PropTypes.func,
  onCliCkRejectCuration : PropTypes.func,
  onPageChange          : PropTypes.func,
  onClickChangeStatus   : PropTypes.func,
  onClickUpdatePrice    : PropTypes.func
}

const defaultProps = {
  isLoading             : false,
  onClickWebsite        : () => { },
  onClickCurate         : () => { },
  onCliCkRejectCuration : () => { },
  onPageChange          : () => { },
  onClickChangeStatus   : () => { },
  onClickUpdatePrice    : () => { }
}

const ScraperProductTable = ({
  tableProps,
  scraperProducts,
  pagination,
  isLoading,
  onPageChange,
  onClickWebsite,
  onClickCurate,
  onCliCkRejectCuration,
  onClickChangeStatus,
  onClickUpdatePrice
}) => {
  const totalColumns = 11
  const TableContent = () => (
    <Table { ...tableProps }>
      <thead>
        <tr>
          <th colSpan={ 10 } className='text-center'>
            { 'Scraper Product Attributes' }
          </th>
          <th colSpan={ 3 } className='text-center'>
            { 'Productable Attributes' }
          </th>
          <th rowSpan={ 2 } className='text-center'>action</th>
        </tr>
        <tr>
          <th scope="col">id</th>
          <th scope="col">origin sku</th>
          <th scope="col">gender</th>
          <th scope="col">brand</th>
          <th scope="col">brand class</th>
          <th scope="col">category</th>
          <th scope="col">available on source</th>
          <th scope="col">buying price</th>
          <th scope="col">curation status</th>
          <th scope="col">website</th>
          <th scope="col">in stock</th>
          <th scope="col">selling price</th>
          <th scope="col">product status</th>
        </tr>
      </thead>
      <tbody>
        {
          scraperProducts.map((scraperProduct) => (
            <ScraperProductTableRow
              key={ `ScraperProductTableRow-${scraperProduct.id}` }
              scraperProduct={ scraperProduct }
              onClickWebsite={ onClickWebsite }
              onClickCurate={ onClickCurate }
              onCliCkRejectCuration={ onCliCkRejectCuration }
              onClickChangeStatus={ onClickChangeStatus }
              onClickUpdatePrice={ onClickUpdatePrice }
            />
          ))
        }

        {
          scraperProducts.length === 0 &&
          <tr>
            <td
              colSpan={ totalColumns }
              className='bg-warning text-white'
            >
              <i className='fas fa-info-circle mr-3' />
              { 'No Scraper Product found based on your filters.' }
            </td>
          </tr>
        }
      </tbody>
    </Table>
  )

  const TableContentWithLoader = withLoader(TableContent, CardLoader)

  return (
    <>
      <TableContentWithLoader isLoading= { isLoading } />

      <PaginationBar
        onClickPage={ onPageChange }
        pagination={ pagination }
      />
    </>
  )
}

ScraperProductTable.propTypes    = propTypes
ScraperProductTable.defaultProps = defaultProps

export default ScraperProductTable
